import React from 'react';
import { observer } from 'mobx-react-lite';
import QuestionLayout from './QuestionLayout';

const QuestionsAndAnswers = observer(function QuestionsAndAnswers({ faqs }) {
  const questions = faqs.map((faq) => (
    <QuestionLayout key={faq.question} faq={faq} />
  ));

  return <div className="faq-questions-and-answers">{questions}</div>;
});

export default QuestionsAndAnswers;
